import { useStatusStore, type AgentStatus } from '../stores/status.store'
import { useTerminalStore } from '../stores/terminal.store'
import { dbgEvent } from '../lib/debug'

export const statusHandler = {
  onStatusChanged(sessionId: string, data: { status: string; error?: string }): void {
    dbgEvent('Zustand', 'status.onStatusChanged', { sessionId: sessionId.slice(0, 8), status: data.status })
    useStatusStore.getState().setStatus(sessionId, data.status as AgentStatus)

    // TERM (client-only, journal-minidev-tout-afficher-terminal-pulsar-2026-08-11) : status:changed
    // porte parfois un champ error (ex. sessions.ts createSession catch) — jusqu'ici tronqué par le
    // cast de subscriptions.ts:routeStatus avant d'arriver ici. Ajout PUR dans terminal.store.ts.
    if (data.error) {
      useTerminalStore.getState().appendClientError(sessionId, data.error)
    }
  },
}
